



























































































































































































import { Vue, Component, Prop } from 'vue-property-decorator';
import XLSX from 'xlsx';  
import { EUserStatus, EUserGroup, IReportable } from "@/components/shared/types";
import { ICodeList, IMapFilter, IMapLayer } from "@/components/map/types";
import Map from "@/components/map/Map";
import { User } from "@/components/User";
import { L, D } from "@/common/filters";
import { isMobile, createDate, SameDateOfNMonthsAfter } from "@/common/utils";
import { DEFAULT_BASEMAP } from '@/components/map/data/basemaps';
const MAX_WAIT_TIME = 60;
@Component({
  watch: {
    /*pagination: {
      handler() {
        this.fetchData();
      }
    },*/
    refresher: {
      handler(value) {
        this.fetchData();
      }
    }
  }
})
export default class Dashboard extends Vue {
  @Prop({
    default : null
  }) data: {[key:string]:any};
  @Prop({
    default: null
  }) refresher: number;

  $map: Map;
  mapLayer: IMapLayer;

  Report: IReportable = {};
  TheDonut: any = {};
  TheTotals = [];
  Charts = [];

  RowsPerPage = [100];
  loading:boolean = false;
  loadingChild:boolean = false;

  pagination:any = {};
  showTable:boolean = true;
  timer = null;
  waitingMaxTime:number = MAX_WAIT_TIME;
  waitingTime:number = MAX_WAIT_TIME;

  colIndex = {
    adminArea: 1,
    landArea: 2,
    landPercent: 3,
    landRegistered: 4,
    landUnRegistered: 5,
    landCount: 6,
    landRegisteredCount: 7,
    landUnRegisteredCount: 8,
    farmerCount: 9,
    cropTypeCount: 10,
    cropGenusCount: 11,
    cropSpeciesCount: 12,
    slopedLand: 14,
    dryLand: 20,
    moistLand: 26,
    wetLand: 32,
    naLand: 38,
    floodedRai0: 10,
    floodedRai1: 10,
    floodedRai2: 10,
    floodedRai3: 10,
    floodedCount0: 10,
    floodedCount1: 10,
    floodedCount2: 10,
    floodedCount3: 10,
    suitable: 10,
    unsuitable: 10,
    suitableNA: 10,
    inRid: 10,
    outRid: 10,
    inAlro: 10,
    outAlro: 10,
    inForest: 10,
    outForest: 10,
    yieldCassava: -1,
    yieldMaize: -1,
    yieldRice: -1,
    yieldSugarcane: -1,
    yield: -1 //tambon level
  };
  get isMobile() : boolean {
    return isMobile();
  };

  get WindowWidth() : number {
    return this.$store.getters.WindowWidth;
  }

  set WindowWidth(value:number) {
    this.$store.commit('notifyChange', {
      WindowWidth: value
    });
  }

  get isSmallOrMobile() : boolean {
    return this.isMobile || this.WindowWidth<576;
  }

  get User() : User {
    return this.$store.getters.User;
  }

  get language() : string {
    return this.$store.getters.Language;
  };

  isYield() : boolean {
    return this.mapLayer && !!this.mapLayer.uri.match(/yield/);
  }

  isYieldEcoplant() : boolean {
    return this.mapLayer && this.mapLayer.uri=='yield_forecast';
  }

  isYieldGISagro() : boolean {
    return this.mapLayer && this.mapLayer.uri=='farmland_yield';
  }

  isArea() : boolean {
    return this.mapLayer && this.mapLayer.uri=='farmland_area';
  }

  isFlood() : boolean {
    return this.mapLayer && this.mapLayer.uri=='farmland_flooded';
  }

  Title() : string {
    let t = (<string> this.mapLayer.title) || 'พื้นที่เกษตร';
    t = t.replace(' (รายแปลง)','').replace(' (Ecoplant)','');
    let f = this.data ? this.data.filter : null;
    if (this.isArea()) {
      if (f) {
        t = f.CropText ? 'พื้นที่ปลูก' + f.CropText : t;
        t += f.AreaText ? ' ' + f.AreaText : '';
      }
    } else {//if (this.isYieldEcoplant()) {
      if (f) {
        t += f.CropText ? '' + f.CropText : '';
        t += f.AreaText ? ' ' + f.AreaText : '';
      }
    }
    return t;
  }

  ExpandedClass(item) : string {
    let report:IReportable = item.parent ? item.parent.report : this.Report;
    return report.expandedRow && report.expandedRow==item ?
           'expanded' + item.level + ' selected' : 
           !!item.parent ? 'expanded' + item.level : '';
  }

  ExpandedIconName(item) : string {
    let report:IReportable = item.parent ? item.parent.report : this.Report;
    return report.expandedRow && report.expandedRow==item ?
           'mdi-minus-box-outline' : 'mdi-plus-box-outline';;
  }

  Columns(item) {
    return item.parent ? item.parent.report.columns : this.Report.columns;
  }

  //showData(value, dataType) {
  showData(row,col) {
    let cName = col.value;
    let cDataType = col.dataType;
    let cValue = row[cName];
    return !cValue ? (cDataType=='number' ? 0 : '') :
           (cDataType!='number' || cName.match(/^รหัส/)) ? cValue :
           cValue.toThousandCommaString((cValue+'').indexOf('.')>0 ? 0 : 0);
  }

  hasReport(item) {
    //item.report implements IReportable
    return !!item && !!item.report && item.report.rows.length>0;
  }

  created() {
    this.fetchData();
  }

  mounted() {
    this.timer = setInterval(() => {
      if (!this.waitingTime) {
        this.waitingTime = MAX_WAIT_TIME;
      }
      this.waitingTime--;
    }, 1000);
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
  }

  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
    }
    let st = this.$refs.scrollTable;
    if (st) {
      let tb = st['$el'].querySelector('tbody');
      tb.removeEventListener("scroll", this.syncTableScroll);
    }
  }

  sortReport(items, headerName, isDescending) {
    //items is a copy of this.Report.rows;
    if (headerName) {
      let isNumber = false;
      let i, headerIndex;
      for (i=0; i<this.Report.columns.length; i++) {
        if (this.Report.columns[i].value==headerName) {
          headerIndex = i;
          isNumber = (this.Report.columns[i].dataType=='number');
          break;
        }
      }
      let report:IReportable;
      let expandedRow = this.Report.expandedRow;
      if (!expandedRow) {
        items = this.doSortReport(items, headerName, isDescending, isNumber);
      } else {
        //this.removeExpandedRows(expandedRow); 
        //recopy items to exclude all expanded child rows
        items = [];
        this.Report.rows.forEach((row) => {
          if (row.level==0) {
            items.push(row);
          }
        });
        items = this.doSortReport(items, headerName, isDescending, isNumber);
        report = expandedRow.report;
        while (report) {
          headerName = report.columns[headerIndex].value;
          let rows = report.rows.map((row) => {
            return row;
          })
          rows = this.doSortReport(rows, headerName, isDescending, isNumber);
          let rowIdx = items.indexOf(expandedRow);
          items.splice(rowIdx+1,0,...rows);
          expandedRow = report.expandedRow;
          report = expandedRow ? expandedRow.report : null;
        }
      }
    }
    return items;
  }
  
  doSortReport(items, headerName, isDescending, isNumber) {
    items.sort((a, b) => {
      try {
        if (!isDescending) {
          return isNumber ? a[headerName] < b[headerName] ? -1 : 1 :
                a[headerName].localeCompare(b[headerName]);
        } else {
          return isNumber ? b[headerName] < a[headerName] ? -1 : 1 :
                b[headerName].localeCompare(a[headerName]);
        }
      } catch(error) {
        console.log(error);
      }
    });
    return items;
  }

  removeExpandedRows(expanded) {
    let report = this.Report;
    let rowIdx:number = report.rows.indexOf(expanded);
    let i, n=0;
    for (i=rowIdx+1; i<report.rows.length; i++) {
      let r = report.rows[i];
      if (r.parent && r.level>expanded.level) {
        n++;
        if (r.parent.report && r.parent.report.expandedRow) {
          r.parent.report.expandedRow = null;
        }
      } else {
        break;
      }
    }
    report.rows.splice(rowIdx+1,n);
  }

  params: any = {
    //offset: (this.pagination.page - 1) * this.pagination.rowsPerPage,
    //limits: this.pagination.rowsPerPage
  };
  YieldStartDate:Date = new Date();
  async fetchData() {
    this.waitingTime = MAX_WAIT_TIME;
    try {
      this.Report = {
        columns: [],
        rows: [],
        sumRow: null,
        expandedRow: null,
        child: null
      };
      this.params = {};
      if (this.data) {
        this.$map = this.data.$map;
        //this.filter = this.data.filter;
        this.mapLayer = this.data.layer;
        this.Report.title = this.Title();
      }
      this.Report.level = 'country';
      let cql = this.$map.map.Filter;
      let filter:IMapFilter = {};
      let n:number;
      let yieldCrops:string[] = [ 'มันสําปะหลัง','ข้าวโพด','ข้าว','อ้อย' ];
      let yieldColors:string[] = [ '#986633', '#ff6666', '#ffc107', '#009485' ];
      if (cql) {
        for (let p in cql) {
          let v = cql[p];
          n = v.indexOf('=') + 1;
          if (p=='aag') {
            v = v.substr(n);
            this.params.aag = parseInt(v);
            this.Report.level = (v.length==2) ? 'province' :
                        (v.length==4) ? 'amphoe' : 'tambon';
          } else if (p=='crop') {
            if (this.isYield()) {
              let f = this.data ? this.data.filter : null;
              if (f && f.CropText) {
                if (f.CropText.match(/อ้อย/)) {
                  this.params.plant = 1;
                  yieldCrops = [ 'อ้อย' ];
                } else if (f.CropText.match(/ข้าวโพด/i)) {
                  this.params.plant = 4;
                  yieldCrops = [ 'ข้าวโพด' ];
                } else if (f.CropText.match(/ข้าว/i)) {
                  this.params.plant = 2;
                  yieldCrops = [ 'ข้าว' ];
                } else if (f.CropText.match(/มันสําปะหลัง/i)) {
                  this.params.plant = 8;
                  yieldCrops = [ 'มันสําปะหลัง' ];
                } else {
                  this.params.plant = 0;
                  throw 'no-data';
                }
              }
            } else {
              if (v.match(/^crop_fk/)) {
                this.params.crop_species = parseInt(v.substr(n));
              } else if (v.match(/^genus_fk/)) {
                this.params.crop_genus = parseInt(v.substr(n));
              } else {
                this.params.crop_type = parseInt(v.substr(n));
              }
            }
          } else if (p=='deed' && this.isArea()) {
            this.params.deed = v.substr(n).replace(/\'/g,'');
          } else if (p=='year' && this.isArea()) {
            if (v.match(/^grow/)) {
              this.params.grow_year = parseInt(v.substr(n));
            } else {
              this.params.harvest_year = parseInt(v.substr(n));
            }
          } else if (p=='area' && this.isArea()) {
            let sqm;
            if (v.match(/\<=|\>=|=/)) {
              this.params.area_op = v.match(/\<=/) ? 'lte' : 
                               v.match(/\>=/) ? 'gte' : 'eq';
              sqm = parseFloat(v.substr(n));
              this.params.rai1 = Math.floor(sqm / 1600);
              sqm -= this.params.rai1 * 1600;
              this.params.ngan1 = Math.floor(sqm / 400);
              sqm -= this.params.ngan1 * 400;
              this.params.sqwah1 = Math.floor(sqm / 4);
            } else if (v.match(/between/i) && v.match(/and/i)) {
              this.params.area_op = 'between';
              let k, b, a, sqm2;
              [k,b,sqm,a,sqm2] = v.split(' ');
              [sqm,sqm2].forEach((area,index) => {
                this.params['rai' + index] = Math.floor(area / 1600);
                area -= this.params['rai' + index] * 1600;
                this.params['ngan' + index] = Math.floor(area / 400);
                area -= this.params['ngan' + index] * 400;
                this.params['sqwah' + index] = Math.floor(area / 4);
              });
            }
          }
        }
      }
      let url = 'mis/report/' + this.mapLayer.uri + '_' + this.Report.level;
      this.loading = true;
      let Total = {};
      let data:any = await this.User.requestResource(url, 'GET', this.params);
      let col:any,cols;
      let idColIndex:number = 0;
      let yieldDateColIndex:number = 0;
      let colIndexes = [];
      if (data) {
        cols = data.columns;
        this.Report.columns = [];
        this.Charts = [{
            type: 'area',
            title: 'จำนวนพื้นที่เกษตร' + (
                  this.Report.level=='country' ? 'ใน 77 จังหวัด' : ' ' + this.data.filter.AreaText
                  ) + ' (ไร่)',
            color: '#b00',
            data: []
          },{
            type: 'column',
            title: 'จำนวนแปลง' + (
                  this.Report.level=='country' ? 'ใน 77 จังหวัด' : ' ' + this.data.filter.AreaText
                  ),
            color: '#b00',
            data: []
          },{
            type: 'line',
            title: 'จำนวนเกษตรกรที่ขึ้นทะเบียน' + (
                  this.Report.level=='country' ? 'ใน 77 จังหวัด' : ' ' + this.data.filter.AreaText
                  ),
            color: '#b00',
            data: []
          },{
            type: 'column',
            title: 'จำนวนชนิดพืชที่ปลูก' + (
                  this.Report.level=='country' ? 'ใน 77 จังหวัด' : ' ' + this.data.filter.AreaText
                  ) + ' (ชนิด)',
            color: '#b00',
            data: []
          }];
        switch (this.mapLayer.uri) {
        case 'farmland_soilclass':
          this.Charts.forEach((chart) => {
            chart.data = [{
                name: 'ที่สูง',
                color: '#f44336',
                data: [],
              },{
                name: 'เขตดินแห้ง',
                color: '#ffc107',
                data: [],
              },{
                name: 'เขตดินชื้น',
                color: '#00bcd4',
                data: [],
              },{
                name: 'พื้นที่น้ำขัง',
                color: '#2196f3',
                data: [],
              },{
                name: 'พื้นที่อื่นๆ',
                color: '#9e9e9e',
                data: [],
              }];
          });
          break;
        case 'farmland_flooded':
          this.Charts = [{
              type: 'area',
              title: 'จำนวนพื้นที่ที่ได้รับน้ำท่วม' + (
                    this.Report.level=='country' ? 'ใน 77 จังหวัด' : ' ' + this.data.filter.AreaText
                    ) + ' (ไร่)',
              data: []
            },{
              type: 'column',
              title: 'จำนวนแปลงที่ได้รับน้ำท่วม' + (
                    this.Report.level=='country' ? 'ใน 77 จังหวัด' : ' ' + this.data.filter.AreaText
                    ),
              data: []
            }];
          this.Charts.forEach((chart) => {
            chart.data = [{
                name: 'ไม่เคยท่วม',
                color: '#4caf50',
                data: [],
              },{
                name: 'ท่วม 1 ครั้ง',
                color: '#ffeb3b',
                data: [],
              },{
                name: 'ท่วม 2 ครั้ง',
                color: '#ffc107',
                data: [],
              },{
                name: 'ท่วม 3 ครั้งขั้นไป',
                color: '#f44336',
                data: [],
              }];
          });
          break;
        case 'farmland_suitability':
          this.Charts = [{
              type: 'area',
              title: 'จำนวนพื้นที่ตามความเหมาะสมการปลูก' + (
                    this.Report.level=='country' ? 'ใน 77 จังหวัด' : ' ' + this.data.filter.AreaText
                    ) + ' (ไร่)',
              data: []
            },{
              type: 'column',
              title: 'จำนวนแปลงตามความเหมาะสมการปลูก' + (
                    this.Report.level=='country' ? 'ใน 77 จังหวัด' : ' ' + this.data.filter.AreaText
                    ),
              data: []
            },{
              type: 'line',
              title: 'จำนวนเกษตรกรที่ตามความเหมาะสมการปลูก' + (
                    this.Report.level=='country' ? 'ใน 77 จังหวัด' : ' ' + this.data.filter.AreaText
                    ),
              data: []
            }];
          this.Charts.forEach((chart) => {
            chart.data = [{
                name: 'ไม่มีข้อมูล',
                color: '#9e9e9e',
                data: [],
              },{
                name: 'ปลูกพืชที่ไม่เหมาะสม',
                color: '#f44336',
                data: [],
              },{
                name: 'ปลูกพืชที่เหมาะสม',
                color: '#4caf50',
                data: [],
              }];
          });
          break;
        case 'farmland_in_rid_area':
          this.Charts = [{
            type: 'area',
            title: 'พื้นที่เกษตรตามเขตชลประทาน' + (
                  this.Report.level=='country' ? 'ใน 77 จังหวัด' : ' ' + this.data.filter.AreaText
                  ) + ' (ไร่)',
            data: []
          },{
            type: 'column',
            title: 'จำนวนแปลงตามเขตชลประทาน' + (
                  this.Report.level=='country' ? 'ใน 77 จังหวัด' : ' ' + this.data.filter.AreaText
                  ),
            data: []
          },{
            type: 'line',
            title: 'จำนวนเกษตรกรตามเขตชลประทาน' + (
                  this.Report.level=='country' ? 'ใน 77 จังหวัด' : ' ' + this.data.filter.AreaText
                  ),
            data: []
          }];
          this.Charts.forEach((chart) => {
            chart.data = [{
                name: 'นอกเขต',
                color: '#f44336',
                data: [],
              },{
                name: 'ในเขต',
                color: '#ffc107',
                data: [],
              }];
          });
          break;
        case 'farmland_in_forest':
          this.Charts = [{
            type: 'area',
            title: 'พื้นที่เกษตรตามการทับซ้อนเขตป่า' + (
                  this.Report.level=='country' ? 'ใน 77 จังหวัด' : ' ' + this.data.filter.AreaText
                  ) + ' (ไร่)',
            data: []
          },{
            type: 'column',
            title: 'จำนวนแปลงตามการทับซ้อนเขตป่า' + (
                  this.Report.level=='country' ? 'ใน 77 จังหวัด' : ' ' + this.data.filter.AreaText
                  ),
            data: []
          },{
            type: 'line',
            title: 'จำนวนเกษตรกรตามการทับซ้อนเขตป่า' + (
                  this.Report.level=='country' ? 'ใน 77 จังหวัด' : ' ' + this.data.filter.AreaText
                  ),
            data: []
          }];
          this.Charts.forEach((chart) => {
            chart.data = [{
                name: 'ไม่ทับซ้อน',
                color: '#4caf50',
                data: [],
              },{
                name: 'ทับซ้อน',
                color: '#f44336',
                data: [],
              }];
          });
          break;
        case 'farmland_in_alro':
          this.Charts = [{
            type: 'area',
            title: 'พื้นที่เกษตรตามเขต ส.ป.ก.' + (
                  this.Report.level=='country' ? 'ใน 77 จังหวัด' : ' ' + this.data.filter.AreaText
                  ) + ' (ไร่)',
            data: []
          },{
            type: 'column',
            title: 'จำนวนแปลงตามเขต ส.ป.ก.' + (
                  this.Report.level=='country' ? 'ใน 77 จังหวัด' : ' ' + this.data.filter.AreaText
                  ),
            data: []
          },{
            type: 'line',
            title: 'จำนวนเกษตรกรตามเขต ส.ป.ก.' + (
                  this.Report.level=='country' ? 'ใน 77 จังหวัด' : ' ' + this.data.filter.AreaText
                  ),
            data: []
          }];this.Charts.forEach((chart) => {
            chart.data = [{
                name: 'นอกเขต ส.ป.ก.',
                color: '#f44336',
                data: [],
              },{
                name: 'ในเขต ส.ป.ก.',
                color: '#4caf50',
                data: [],
              }];
          });
          break;
        case 'farmland_yield':
        case 'yield_forecast':
          this.Charts = yieldCrops.map((crop, i) => {
            return {
                type: 'line',
                color: yieldColors[i],
                title: 'การคาดการณ์ผลผลิต' + crop + (
                      this.Report.level=='country' ? 'ใน 77 จังหวัด' : ' ' + this.data.filter.AreaText
                      ) + ' (ตัน)',
                data: []
              }
          });
          break;
        case 'farmland_area':
        default:
          this.Charts.forEach((chart) => {
            chart.data = [];
          });
        }
        this.colIndex.yieldCassava = -1;
        this.colIndex.yieldMaize = -1;
        this.colIndex.yieldRice = -1;
        this.colIndex.yieldSugarcane = -1;
        this.colIndex.yield = -1;
        cols.forEach((col,i) => {
          if (col.name=='รหัส') {
            idColIndex = i;
            //skip it
          } else if (col.name.match(/^รหัส/) ||
              (this.params.plant==1 && col.name.match(/ข้าว|มันสำปะหลัง/)) || 
              (this.params.plant==2 && col.name.match(/อ้อย|ข้าวโพด|มันสำปะหลัง/)) || 
              (this.params.plant==4 && col.name.match(/อ้อย|^ข้าว$|มันสำปะหลัง/)) || 
              (this.params.plant==8 && col.name.match(/อ้อย|ข้าว/))) {
            //skip it
          } else if (col.name.match(/^yield_date|^month_01|เดือนเริ่มต้น/)) {
            yieldDateColIndex = i;
            if (data.data && data.data.length>0) {
              this.YieldStartDate = createDate(data.data[0][i]);
            }
            //skip it
          } else {
            let n, d;
            if (col.name.match(/มันสำปะหลัง|ข้าว|อ้อย/)) {
              n = parseInt(col.name.replace(/\D/g, '')) - 1;
              //d = D(((n==0) ? this.YieldStartDate : 
              //           SameDateOfNMonthsAfter(n,this.YieldStartDate)),'yyyy-MM');
              d = ((n==0) ? this.YieldStartDate : 
                  SameDateOfNMonthsAfter(n,this.YieldStartDate))
                  .toISOString().substr(0,7);
              if (this.params && this.params.plant) {
                col.name = d;
              } else {
                if (col.name.match(/มันสำปะหลัง/)) {
                  //col.name = d + ' (มันสําปะหลัง)';
                  col.name = 'มันสําปะหลัง (' + d + ')';
                } else if (col.name.match(/ข้าวโพด/)) {
                  //col.name = d + ' (ข้าวโพด)';
                  col.name = 'ข้าวโพด (' + d + ')';
                } else if (col.name.match(/ข้าว/)) {
                  //col.name = d + ' (ข้าว)';
                  col.name = 'ข้าว (' + d + ')';
                } else if (col.name.match(/อ้อย/)) {
                  //col.name = d + ' (อ้อย)';
                  col.name = 'อ้อย (' + d + ')';
                }
              }
            }
            this.Report.columns.push({
              text: col.name,
              align: col.dataType=='number' ? 'right' : 'left',
              dataType: col.dataType,
              value: col.name,
              width: '100px'
            });
            n = this.Report.columns.length - 1;;
            if (col.name.match(/^พื้นที่/) && col.name.match(/(ตร.กม)/)) {
              this.colIndex.adminArea = n;
            } else if (col.name=='พื้นที่ปลูก (ไร่)') {
              this.colIndex.landArea = n;
            } else if (col.name.match(/(%)$/)) {
              this.colIndex.landPercent = n;
            } else if (col.name=='มีเลขแล้ว (ไร่)') {
              this.colIndex.landRegistered = n;
            } else if (col.name=='ยังไม่มีเลข (ไร่)') {
              this.colIndex.landUnRegistered = n;
            } else if (col.name=='จำนวนแปลง') {
              this.colIndex.landCount = n;
            } else if (col.name=='มีเลขแล้ว (แปลง)') {
              this.colIndex.landRegisteredCount = n;
            } else if (col.name=='ยังไม่มีเลข (แปลง)') {
              this.colIndex.landUnRegisteredCount = n;
            } else if (col.name=='จำนวนเกษตรกร') {
              this.colIndex.farmerCount = n;
            } else if (col.name=='จำนวนประเภทพืช') {
              this.colIndex.cropTypeCount = n;
            } else if (col.name=='จำนวนชนิดพืช') {
              this.colIndex.cropGenusCount = n;
            } else if (col.name=='จำนวนพันธุ์พืช') {
              this.colIndex.cropSpeciesCount = n;
            } else if (col.name=='ที่สูง (ไร่)') {
              this.colIndex.slopedLand = n;
            } else if (col.name=='เขตดินแห้ง (ไร่)') {
              this.colIndex.dryLand = n;
            } else if (col.name=='เขตดินชื้น (ไร่)') {
              this.colIndex.moistLand = n;
            } else if (col.name=='พื้นที่น้ำขัง (ไร่)') {
              this.colIndex.wetLand = n;
            } else if (col.name=='พื้นที่อื่นๆ (ไร่)') {
              this.colIndex.naLand = n;
            } else if (col.name=='ไม่เคยท่วม (ไร่)') {
              this.colIndex.floodedRai0 = n;
            } else if (col.name=='ท่วม 1 ครั้ง (ไร่)') {
              this.colIndex.floodedRai1 = n;
            } else if (col.name=='ท่วม 2 ครั้ง (ไร่)') {
              this.colIndex.floodedRai2 = n;
            } else if (col.name=='ท่วม 3 ครั้งขึ้นไป (ไร่)') {
              this.colIndex.floodedRai3 = n;
            } else if (col.name=='ไม่เคยท่วม (แปลง)') {
              this.colIndex.floodedCount0 = n;
            } else if (col.name=='ท่วม 1 ครั้ง (แปลง)') {
              this.colIndex.floodedCount1 = n;
            } else if (col.name=='ท่วม 2 ครั้ง (แปลง)') {
              this.colIndex.floodedCount2 = n;
            } else if (col.name=='ท่วม 3 ครั้งขึ้นไป (แปลง)') {
              this.colIndex.floodedCount3 = n;
            } else if (col.name=='เหมาะสม (ไร่)') {
              this.colIndex.suitable = n;
            } else if (col.name=='ไม่เหมาะสม (ไร่)') {
              this.colIndex.unsuitable = n;
            } else if (col.name=='ไม่มีข้อมูล (ไร่)') {
              this.colIndex.suitableNA = n;
            } else if (col.name=='ทับซ้อนเขตป่า (ไร่)') {
              this.colIndex.inForest = n;
            } else if (col.name=='ไม่ทับซ้อนเขตป่า (ไร่)') {
              this.colIndex.outForest = n;
            } else if (col.name=='ในเขต (ไร่)') {
              this.colIndex.inRid = n;
            } else if (col.name=='นอกเขต (ไร่)') {
              this.colIndex.outRid = n;
            } else if (col.name=='ในเขต ส.ป.ก. (ไร่)') {
              this.colIndex.inAlro = n;
            } else if (col.name=='นอกเขต ส.ป.ก. (ไร่)') {
              this.colIndex.outAlro = n;
            } else if (this.colIndex.yieldCassava==-1 && 
              col.name.match(/^มันสําปะหลัง/)) {
              this.colIndex.yieldCassava = n;
            } else if (this.colIndex.yieldMaize==-1 && 
              col.name.match(/^ข้าวโพด/)) {
              this.colIndex.yieldMaize = n;
            } else if (this.colIndex.yieldRice==-1 && 
              col.name.match(/^ข้าว/)) {
              this.colIndex.yieldRice = n;
            } else if (this.colIndex.yieldSugarcane==-1 && 
              col.name.match(/^อ้อย/)) {
              this.colIndex.yieldSugarcane = n;
            } else if (this.colIndex.yield==-1 && 
              col.name.match(/เดือน 01 (ตัน)/)) {
              this.colIndex.yield = n;
            }
          }
        });
        this.Report.rows = data.data.map((dd,ddIdx) => {
          let r:any = {
            level: 0,
            id: ddIdx
          };
          dd.forEach((d,i) => {
            col = cols[i];
            if (i==idColIndex) {
              r['รหัส'] = d;
              Total['รหัส'] = '';
            } else if (col.dataType=='number') {
              r[col.name] = d;
              if (this.Report.level=='tambon') {
                if (col.name.match(/^พื้นที่ตำบล/)) {
                  Total[col.name] = d;
                } else if (col.name.match(/^จำนวน/) && col.name.match(/ประเภทพืช$|พันธุ์พืช$/)) {
                  Total[col.name] = Math.max((Total[col.name] || 0),d);
                } else {
                  Total[col.name] = (Total[col.name] || 0) + d;
                }
              } else if (col.name.match(/^จำนวน/) && col.name.match(/พืช/)) {
                Total[col.name] = Math.max((Total[col.name] || 0),d);
              } else {
                Total[col.name] = (Total[col.name] || 0) + d;
              }
            } else {
              r[col.name] = d;
              if (col.name.match(/^ชื่อ/)) {
                Total[col.name] = 'รวม';
              } else {
                Total[col.name] = '';
              }
            }
          });
          if (this.mapLayer) {
            let xLabelIndex = 0;
            let cropCountIndex = this.colIndex.cropGenusCount;
            if (this.Report.level=='tambon') {
              xLabelIndex = 3;
              cropCountIndex = this.colIndex.cropSpeciesCount;
              if (this.Charts.length>3) {
                //flooded data has only 2 charts
                this.Charts[3].title = this.Charts[3].title.replace('ชนิด','พันธุ์');
              }
            }
            switch (this.mapLayer.uri) {
            case 'farmland_soilclass':
              colIndexes = [this.colIndex.slopedLand,this.colIndex.dryLand,
                         this.colIndex.moistLand,this.colIndex.wetLand,
                         this.colIndex.naLand];
              this.Charts.forEach((chart,cidx) => {
                if (cidx>0) {
                  cidx++;
                }
                chart.data.forEach((series,sidx) => {
                  chart.data[sidx].data.push([
                    r[this.Report.columns[xLabelIndex].value],
                    Math.round(r[this.Report.columns[colIndexes[sidx] + cidx].value])
                  ]);
                });
              });
              break;
            case 'farmland_flooded':
              colIndexes = [this.colIndex.floodedRai0,this.colIndex.floodedRai1,
                         this.colIndex.floodedRai2,this.colIndex.floodedRai3];
              this.Charts.forEach((chart,cidx) => {
                if (cidx>0) {
                  cidx += 4;
                }
                chart.data.forEach((series,sidx) => {
                  chart.data[sidx].data.push([
                    r[this.Report.columns[xLabelIndex].value],
                    Math.round(r[this.Report.columns[colIndexes[sidx] + cidx].value])
                  ]);
                });
              });
              break;
            case 'farmland_suitability':
              colIndexes = [this.colIndex.suitableNA,this.colIndex.unsuitable,
                         this.colIndex.suitable];
              this.Charts.forEach((chart,cidx) => {
                if (cidx>0) {
                  cidx++;
                }
                chart.data.forEach((series,sidx) => {
                  chart.data[sidx].data.push([
                    r[this.Report.columns[xLabelIndex].value],
                    Math.round(r[this.Report.columns[colIndexes[sidx] + cidx].value])
                  ]);
                });
              });
              break;
            case 'farmland_in_rid_area':
              colIndexes = [this.colIndex.outRid,this.colIndex.inRid];
              this.Charts.forEach((chart,cidx) => {
                if (cidx>0) {
                  cidx++;
                }
                chart.data.forEach((series,sidx) => {
                  chart.data[sidx].data.push([
                    r[this.Report.columns[xLabelIndex].value],
                    Math.round(r[this.Report.columns[colIndexes[sidx] + cidx].value])
                  ]);
                });
              });
              break;
            case 'farmland_in_forest':
              colIndexes = [this.colIndex.outForest,this.colIndex.inForest];
              this.Charts.forEach((chart,cidx) => {
                if (cidx>0) {
                  cidx++;
                }
                chart.data.forEach((series,sidx) => {
                  chart.data[sidx].data.push([
                    r[this.Report.columns[xLabelIndex].value],
                    Math.round(r[this.Report.columns[colIndexes[sidx] + cidx].value])
                  ]);
                });
              });
              break;
            case 'farmland_in_alro':
              colIndexes = [this.colIndex.outAlro,this.colIndex.inAlro];
              this.Charts.forEach((chart,cidx) => {
                if (cidx>0) {
                  cidx++;
                }
                chart.data.forEach((series,sidx) => {
                  chart.data[sidx].data.push([
                    r[this.Report.columns[xLabelIndex].value],
                    Math.round(r[this.Report.columns[colIndexes[sidx] + cidx].value])
                  ]);
                });
              });
              break;
            case 'farmland_yield':
            case 'yield_forecast':
              if (this.Report.level=='tambon') {
                yieldCrops.forEach((crop,idx) => {

                });
              }
              break;
            case 'farmland_area':
            default:
              colIndexes = [this.colIndex.landArea,this.colIndex.landCount,this.colIndex.farmerCount,cropCountIndex];
              this.Charts.forEach((chart,cidx) => {
                if (cidx==0 || (cidx>0 && 
                   (r[this.Report.columns[xLabelIndex].value]!='ไม่ระบุ'))) {
                  chart.data.push([
                    r[this.Report.columns[xLabelIndex].value],
                    Math.round(r[this.Report.columns[colIndexes[cidx]].value])
                  ]);
                }
              });
            }
          }
          return r;
        });
        if (!this.isYieldEcoplant()) {
          let area_sqkm = Total[this.Report.columns[this.colIndex.adminArea].value];
          let land_rai = Total[this.Report.columns[this.colIndex.landArea].value];
          area_sqkm = area_sqkm * (10000/16);
          Total[this.Report.columns[this.colIndex.landPercent].value] = Math.round((land_rai/area_sqkm) * 100);
        }
        this.Report.sumRow = Total;
        let totalLand = this.showData(this.Report.sumRow,this.Report.columns[this.colIndex.landArea]);
        switch (this.mapLayer.uri) {
        case 'farmland_soilclass':
          this.TheDonut = {
            title: 'พื้นที่เกษตรตามสภาพดิน (ไร่)',
            data: [
              ['ที่สูง', Math.round(this.Report.sumRow[this.Report.columns[this.colIndex.slopedLand].value])],
              ['เขตดินแห้ง',Math.round(this.Report.sumRow[this.Report.columns[this.colIndex.dryLand].value])],
              ['เขตดินชื้น',Math.round(this.Report.sumRow[this.Report.columns[this.colIndex.moistLand].value])],
              ['พื้นที่น้ำขัง',Math.round(this.Report.sumRow[this.Report.columns[this.colIndex.wetLand].value])],
              ['พื้นที่อื่นๆ',Math.round(this.Report.sumRow[this.Report.columns[this.colIndex.naLand].value])]
            ],
            colors: ['#f44336','#ffc107','#00bcd4','#2196f3','#9e9e9e' ],
            total: totalLand,
            totalOffset: '26px'
          }
          break;
        case 'farmland_flooded':
          this.TheDonut = {
            title: 'พื้นที่เกษตรที่เสี่ยงต่อจากน้ำท่วม (ไร่)',
            data: [
              ['3 ครั้งขึ้นไป', Math.round(this.Report.sumRow[this.Report.columns[this.colIndex.floodedRai3].value])],
              ['2 ครั้ง',Math.round(this.Report.sumRow[this.Report.columns[this.colIndex.floodedRai2].value])],
              ['1 ครั้ง',Math.round(this.Report.sumRow[this.Report.columns[this.colIndex.floodedRai1].value])],
              ['ไม่เคยท่วม',Math.round(this.Report.sumRow[this.Report.columns[this.colIndex.floodedRai0].value])]
            ],
            colors: ['#f44336','#ffc107','#ffeb3b','#4caf50' ],
            total: totalLand,
            totalOffset: '26px'
          }
          break;
        case 'farmland_suitability':
          this.TheDonut = {
            title: 'พื้นที่เกษตรตามความเหมาะสมในการปลูก (ไร่)',
            data: [
              ['ปลูกพืชที่เหมาะสม', Math.round(this.Report.sumRow[this.Report.columns[this.colIndex.suitable].value])],
              ['ปลูกพืชที่ไม่เหมาะสม',Math.round(this.Report.sumRow[this.Report.columns[this.colIndex.unsuitable].value])],
              ['ไม่มีข้อมูล',Math.round(this.Report.sumRow[this.Report.columns[this.colIndex.suitableNA].value])]
            ],
            colors: ['#4caf50','#f44336','#9e9e9e' ],
            total: totalLand,
            totalOffset: '26px'
          }
          break;
        case 'farmland_in_rid_area':
          this.TheDonut = {
            title: 'พื้นที่เกษตรที่เสี่ยงต่อจากน้ำท่วม (ไร่)',
            data: [
              ['นอกเขตชลประทาน', Math.round(this.Report.sumRow[this.Report.columns[this.colIndex.outRid].value])],
              ['ในเขตชลประทาน',Math.round(this.Report.sumRow[this.Report.columns[this.colIndex.inRid].value])]
            ],
            colors: ['#f44336','#2196f3' ],
            total: totalLand
          }
          break;
        case 'farmland_in_forest':
          this.TheDonut = {
            title: 'พื้นที่เกษตรที่ทับซ้อนเขตป่า (ไร่)',
            data: [
              ['ไม่ทับซ้อนเขตป่า', Math.round(this.Report.sumRow[this.Report.columns[this.colIndex.outForest].value])],
              ['ทับซ้อนเขตป่า',Math.round(this.Report.sumRow[this.Report.columns[this.colIndex.inForest].value])]
            ],
            colors: ['#4caf50', '#f44336' ],
            total: totalLand
          }
          break;
        case 'farmland_in_alro':
          this.TheDonut = {
            title: 'พื้นที่เกษตรตามเขต ส.ป.ก. (ไร่)',
            data: [
              ['นอกเขต ส.ป.ก.', Math.round(this.Report.sumRow[this.Report.columns[this.colIndex.outAlro].value])],
              ['ในเขต ส.ป.ก.',Math.round(this.Report.sumRow[this.Report.columns[this.colIndex.inAlro].value])]
            ],
            colors: ['#f44336','#4caf50' ],
            total: totalLand
          }
          break;
        case 'farmland_yield':
        case 'yield_forecast':
          if (this.Report.level!='tambon') {
            let totalYield = 0;
            colIndexes = [
              this.colIndex.yieldCassava, this.colIndex.yieldMaize,
              this.colIndex.yieldRice, this.colIndex.yieldSugarcane
            ];
            this.TheDonut = {
              title: 'การคาดการณ์ผลผลิต (ตัน)',
              data: [],
              colors: yieldColors,
              total: totalYield.toThousandCommaString(0),
              totalOffset: yieldCrops.length==1 ? '16px' : '38px'
            }
            this.Charts.forEach((chart,i) => {
              for (let m=0; m<12; m++) {
                let colName = this.Report.columns[colIndexes[i] + m*4].value;
                let colMonth = colName.substring(colName.indexOf('(')+1).replace(')','');
                let yieldVal = Math.round(this.Report.sumRow[colName] || 0);
                chart.data.push([ colMonth, yieldVal ]);
                if (this.TheDonut.data.length<=i && !!yieldVal) {
                  totalYield += yieldVal;
                  this.TheDonut.data.push([ colName, yieldVal ]);
                }
              }
            });
            this.TheDonut.total = totalYield.toThousandCommaString(0);
          }
          break;
        case 'farmland_area':
        default:
          this.TheDonut = {
            title: 'พื้นที่เกษตรตามการขึ้นทะเบียนเกษตรกร (ไร่)',
            data: [
              ['ขึ้นทะเบียนแล้ว', Math.round(this.Report.sumRow[this.Report.columns[this.colIndex.landRegistered].value])],
              ['ยังไม่ขึ้นทะเบียน',Math.round(this.Report.sumRow[this.Report.columns[this.colIndex.landUnRegistered].value])]
            ],
            colors: ['#4caf50', '#f44336'],
            total: totalLand
          }
        }
        this.TheTotals = [{
            title: 'จำนวนแปลง',
            value: this.showData(this.Report.sumRow,this.Report.columns[this.colIndex.landCount]),
            style: {color:'#fff', background:'#4caf50'}
          },{
            title: 'จำนวนเกษตรกร (คน)',
            value: this.showData(this.Report.sumRow,this.Report.columns[this.colIndex.farmerCount]),
            style: {color:'#fff', background:'#1e96f0'}
          },{
            title: 'จำนวนพืช (ประเภท/ชนิด/พันธุ์)',
            value: this.showData(this.Report.sumRow,this.Report.columns[this.colIndex.cropTypeCount]) + '/' +
                   this.showData(this.Report.sumRow,this.Report.columns[this.colIndex.cropGenusCount]) + '/' + 
                   this.showData(this.Report.sumRow,this.Report.columns[this.colIndex.cropSpeciesCount]),
            style: {color:'#fff', background:'#ff9800'}
          }]
        if (this.Report.level=='tambon' &&
          this.Report.sumRow[this.Report.columns[this.colIndex.cropGenusCount].value]<=1) {
          // don't show it since there is only one data
          this.Charts = [];
        }
      }
      this.loading = false;
      this.$nextTick(() => {
        this.setTableScroll();
      });
    } catch (error) {
      console.log(error);
      this.Report.rows = [];
      this.loading = false;
    }
  }

  async fetchChild(props) {
    if (this.Report.level=='tambon') {
      return;
    }
    let row:{[key:string] : any} = props.item;
    let aag = row['รหัส'] + '';
    let level = (aag.length==2) ? 'province' : (aag.length==4) ? 'amphoe' : 'tambon';
    let report = row.parent ? row.parent.report : this.Report;
    try {
      if (report.expandedRow) {
        this.removeExpandedRows(report.expandedRow);
      }
      if (report.expandedRow==row) {
        report.expandedRow = null;
        if (level=='tambon') {
          this.Report.child = null; //will not expand
          props.expanded = false;
        }
      } else {
        if (!this.hasReport(row)) {
          this.params.aag = row['รหัส'];
          let url = 'mis/report/' + this.mapLayer.uri + '_' + level;
          this.loadingChild = true;
          row.report = null; //implements IReportable
          let params = Object.assign({},this.params);
          if (this.isYieldEcoplant() && level=='tambon') {
            params.plant = params.plant || 15;
          }
          let data:any = await this.User.requestResource(url, 'GET', params);
          let col:any,cols;
          let idColIndex:number = 0;
          let yieldDateColIndex:number = 0;
          if (data) {
            row.report = {
              columns:[],
              rows: []
            }
            cols = data.columns;
            cols.forEach((col,i) => {
              if (col.name=='รหัส') {
                idColIndex = i;
                //skip it
              } else if (col.name.match(/^รหัส/) ||
                  (this.params.plant==1 && col.name.match(/ข้าว|มันสำปะหลัง/)) || 
                  (this.params.plant==2 && col.name.match(/อ้อย|ข้าวโพด|มันสำปะหลัง/)) || 
                  (this.params.plant==4 && col.name.match(/อ้อย|^ข้าว$|มันสำปะหลัง/)) || 
                  (this.params.plant==8 && col.name.match(/อ้อย|ข้าว/))) {
                //skip it
              } else if (col.name.match(/^yield_date|^month_01|เดือนเริ่มต้น/)) {
                yieldDateColIndex = i;
                if (data.data && data.data.length>0) {
                  this.YieldStartDate = createDate(data.data[0][i]);
                }
                //skip it
              } else if (level!='tambon' || !col.name.match(/^ตำบล|^ชื่อตำบล|^พื้นที่ตำบล/)) {
                let n, d;
                if (this.isYieldEcoplant() && col.name.match(/^yield_ton/)) {
                  n = parseInt(col.name.slice(-2)) - 1;
                  col.name = D(((n==0) ? this.YieldStartDate : 
                            SameDateOfNMonthsAfter(n,this.YieldStartDate)),'MMM yyyy');
                } else if (this.isYieldGISagro() && col.name.match(/มันสำปะหลัง|ข้าว|อ้อย/)) {
                  n = parseInt(col.name.replace(/\D/g, '')) - 1;
                  d = D(((n==0) ? this.YieldStartDate : 
                            SameDateOfNMonthsAfter(n,this.YieldStartDate)),'MMM yyyy');
                  if (this.params && this.params.plant) {
                    col.name = d;
                  } else {
                    if (col.name.match(/มันสำปะหลัง/)) {
                      col.name = d + ' (มันสําปะหลัง)';
                    } else if (col.name.match(/ข้าวโพด/)) {
                      col.name = d + ' (ข้าวโพด)';
                    } else if (col.name.match(/ข้าว/)) {
                      col.name = d + ' (ข้าว)';
                    } else if (col.name.match(/อ้อย/)) {
                      col.name = d + ' (อ้อย)';
                    }
                  }
                }
                row.report.columns.push({
                  text: col.name,
                  align: col.dataType=='number' ? 'right' : 'left',
                  dataType: col.dataType,
                  value: col.name
                });
              }
            });
            row.report.rows = data.data.map((dd, ddIdx) => {
              let r:any = {
                level: row.level+1,
                parent: row,
                id: row.id + '.' + ddIdx
              };
              dd.forEach((d,i) => {
                col = cols[i];
                if (i==idColIndex) {
                  r['รหัส'] = d;
                } else {
                  if (this.isYield() && col.name=='ชนิดพืช') {
                    if (d && d.match(/cassava/i)) {
                      d = this.language=='th' ? 'มันสำปะหลัง' : 'Cassava';
                    } if (d && d.match(/maize/i)) {
                      d = this.language=='th' ? 'ข้าวโพด' : 'Maize';
                    } if (d && d.match(/rice/i)) {
                      d = this.language=='th' ? 'ข้าว' : 'Rice';
                    } if (d && d.match(/sugarcane/i)) {
                      d = this.language=='th' ? 'อ้อย' : 'Sugarcane';
                    }
                  }
                  r[col.name] = d;
                }
              });
              return r;
            });
          }
          this.loadingChild = false;
        }
        report.expandedRow = row;
        if (level=='tambon') {
          this.Report.child = row.report;
          props.expanded = true;
        } else {
          let rowIdx = this.Report.rows.indexOf(row);
          this.Report.rows.splice(rowIdx+1,0,...row.report.rows);
        }
      }
    } catch (error) {
      console.log(error);
      let cols;
      if (level=='tambon') {
        /*if (this.mapLayer.uri=='farmland_area') {
          cols = [{name: "รหัส", dataType: "number"},
          {name: "ชื่อตำบล", dataType: "text"},
          {name: "พื้นที่ตำบล (ตร.กม)", dataType: "number"},
          {name: "กลุ่มพืช", dataType: "text"},
          {name: "ชนิดพืช", dataType: "text"},
          {name: "พันธุ์พืช", dataType: "text"},
          {name: "จำนวนแปลง", dataType: "number"},
          {name: "จำนวนเกษตรกร", dataType: "number"},
          {name: "พื้นที่ปลูก (ตร.กม.)", dataType: "number"},
          {name: "พื้นที่ปลูก (ไร่)", dataType: "number"},
          {name: "พื้นที่ปลูก (%)", dataType: "number"}
          ].map((col) => {
            return {
              text: col.name,
              align: col.dataType=='number' ? 'right' : 'left',
              dataType: col.dataType,
              value: col.name
            }
          });
        } else {
          cols = [{name: "รหัส", dataType: "number"},
                  {name: "ชื่อตำบล", dataType: "text"},
                  {name: "ชนิดพืช", dataType: "text"}
          ];
          for (let i=0; i<12; i++) {
            let name = D((i==0 ? this.YieldStartDate :
                          SameDateOfNMonthsAfter(i,this.YieldStartDate)),'MMM yyyy');
            cols.push({
              text: name,
              align: 'right',
              dataType: 'number',
              value: name
            });
          }
        }*/
        cols = [{
            text: this.Title(),
            align: 'center',
            dataType: 'text',
            value: this.Title()
          }];
        row.report = {
          columns: cols,
          rows: []
        };
        report.expandedRow = row;
        props.expanded = true;
        this.Report.child = row.report;
      } else {
        cols = this.Report.columns.map((col)=>{return col});
        row.report = {
          columns: cols,
          rows: []
        };
      }
      this.loadingChild = false;
    }
  }

  async exportToExcel() {
    try {
      let areaNames, pn='', an='', tn='';
      let f = this.data ? this.data.filter : null;
      if (f && f.AreaText) {
        areaNames = f.AreaText.split(' ');
        if (areaNames.length==3) {
          tn = areaNames[0];
          an = areaNames[1];
          pn = areaNames[2];
        } else if (areaNames.length==2) {
          an = areaNames[0];
          pn = areaNames[1];
        } else if (areaNames.length==1) {
          pn = areaNames[0];
        }
      }
      let sheets = {
        country: {
          name: 'ระดับจังหวัด',
          rows: []
        },
        province: {
          name: pn,
          rows: []
        },
        amphoe: {
          name: an,
          rows: []
        },
        tambon: {
          name: tn,
          rows: []
        }
      }
      this.Report.rows.forEach((row) => {
        let r = {
          'รหัส': row['รหัส']
        };
        if (row.level==0) {
          switch (this.Report.level) {
            case 'tambon':
            case 'amphoe':
              r['ชื่อจังหวัด'] = pn;
              r['ชื่ออำเภอ'] = an;
              break;
            case 'province':
              r['ชื่อจังหวัด'] = pn;
          }
          this.Report.columns.forEach((col) => {
            r[col.value] = !row[col.value] ? col.dataType=='number' ? 0 : '' : row[col.value];
          });
          sheets[this.Report.level].rows.push(r);
        } else if (row.level==1) {
          let level, name;
          if (this.Report.level=='country') {
            r['ชื่อจังหวัด'] = row.parent['ชื่อจังหวัด'];
            sheets.province.name = row.parent['ชื่อจังหวัด'];
            sheets.province.rows.push(r);
          } else if (this.Report.level=='province') {
            r['ชื่อจังหวัด'] = pn;
            r['ชื่ออำเภอ'] = row.parent['ชื่ออำเภอ'];
            sheets.amphoe.name = row.parent['ชื่ออำเภอ'];
            sheets.amphoe.rows.push(r);
          }
          row.parent.report.columns.forEach((col) => {
            r[col.value] = !row[col.value] ? col.dataType=='number' ? 0 : '' : row[col.value];
          });
        } else if (row.level==2) {
          r['ชื่อจังหวัด'] = row.parent.parent['ชื่อจังหวัด'];
          r['ชื่ออำเภอ'] = row.parent['ชื่ออำเภอ'];
          sheets.amphoe.name = row.parent['ชื่ออำเภอ'];
          sheets.amphoe.rows.push(r);
          row.parent.report.columns.forEach((col) => {
            r[col.value] = !row[col.value] ? col.dataType=='number' ? 0 : '' : row[col.value];
          });
        }
      });
      if (sheets[this.Report.level].rows.length>0 && this.Report.sumRow) {
        let r = {};
        for (let k in sheets[this.Report.level].rows[0]) {
          r[k] = this.Report.sumRow[k] || '';
        }
        sheets[this.Report.level].rows.push(r);
      }
      let ws, wb = XLSX.utils.book_new(); // make Workbook of Excel
      ['country','province','amphoe','tambon'].forEach((level) => {
        if (sheets[level].rows.length>0) {
          ws = XLSX.utils.json_to_sheet(sheets[level].rows);
          XLSX.utils.book_append_sheet(wb, ws, sheets[level].name);
        }
      });
      if (this.Report.child && this.Report.child.rows.length>0) {
        let tambon = this.Report.child.rows[0].parent;
        let rows = this.Report.child.rows.map((row) => {
          let r = {
            'รหัส': row['รหัส'],
            'ชื่อจังหวัด': pn || tambon.parent.parent['ชื่อจังหวัด'],
            'ชื่ออำเภอ': an || tambon.parent['ชื่ออำเภอ'],
            'ชื่อตำบล': tambon['ชื่อตำบล'],
            'พื้นที่ตำบล (ตร.กม)': tambon['พื้นที่ตำบล (ตร.กม)']
          }
          this.Report.child.columns.forEach((col) => {
            r[col.value] = !row[col.value] ? col.dataType=='number' ? 0 : '' : row[col.value];
          });
          return r;
        });
        ws = XLSX.utils.json_to_sheet(rows);
        XLSX.utils.book_append_sheet(wb, ws, tambon['ชื่อตำบล']);
      }
      let fileName = (this.mapLayer && this.mapLayer.uri) ? 
                      this.mapLayer.uri : 'gisagro-report';
      XLSX.writeFile(wb, fileName + '.xlsx') ;
      this.loading = false;
    } catch (error) {
      this.loading = false;
      console.log(error);
    }
  }

  printDashboard() {
    let url = window.location.protocol + '//' + 
            window.location.hostname + 
            (window.location.port ? ':' + window.location.port : '') +
            '/printdashboard';
    this.$store.commit('notifyChange', {
      Storage: {
        Title: this.Title(),
        TheDonut: this.TheDonut,
        Report: this.Report,
        TheTotals: this.TheTotals,
        Charts: this.Charts,
        isYieldEcoplant: this.isYieldEcoplant(),
        isSmallOrMobile: this.isSmallOrMobile
      }
    });
    let win = window.open(url, 'gisagroprint');
    win.focus();
  }
  
  setTableScroll() {
    let st = this.$refs.scrollTable;
    if (st) {
      let th = st['$el'].querySelector('thead');
      let tds = th.querySelector('tr').getElementsByTagName('th');
      let i;
      for (i=0; i<tds.length; i++) {
        this.Report.columns[i].width = tds[i].offsetWidth + 'px';
      };
      let tb = st['$el'].querySelector('tbody');
      tb.addEventListener("scroll", this.syncTableScroll);
      this.syncTableScroll();
    }
  }

  syncTableScroll() {
    let st = this.$refs.scrollTable;
    let tb = st['$el'].querySelector('tbody');
    let th = st['$el'].querySelector('thead');
    let tf = st['$el'].querySelector('tfoot');
    let sl = tb.scrollLeft;
    th.scrollLeft = sl;
    tf.scrollLeft = sl;
  }

  closeMe() {
    if (this.mapLayer) {
      this.mapLayer.checked = this.mapLayer.visible = false;
      this.$emit('changeMe', {
        menu: {
          name: 'update_visible_layers'
        }
      });
    }
    this.$emit('closeRightToc');
  }
}
